import * as cheerio from 'cheerio';

export function createId($, title) {
  let id = $(title).attr('id');

  if (!id) {
    id = $(title)
      .text()
      .toLowerCase()
      .replace(/[^a-z_0-9]+/gi, '-')
      .replace(/-+/g, '-');
  }
  return id;
}

/**
 * Generate a unique id from a title string
 * @param {string} title The title to generate an id for
 * @returns
 */
export const generateTitleId = title => {
  return title
    .toLowerCase()
    .replace(/[^a-z_0-9]+/gi, '-')
    .replace(/-+/g, '-');
};

export const createTitleId = $ => {
  const titlesMap = {};
  return title => {
    let id = generateTitleId($(title).text());
    if (titlesMap[id]) {
      // If ID exists, increment the count by 1
      const newIdIndex = titlesMap[id] + 1;
      // Store the count on the id to be the new index
      titlesMap[id] = newIdIndex;
      // Update the ID to include the actual id and the newIdex
      id = `${id}-${newIdIndex}`;
      // Store the id count as one since it is just occurring
      titlesMap[id] = 1;
    } else {
      titlesMap[id] = 1;
    }
    return id;
  };
};

export const createTableOfContents = content => {
  // Convert text html to DOM
  const $ = cheerio.load(content || '');
  // Get all the titles
  const titles = $('h2,h3,h4,h5');
  const getTitleId = createTitleId($);
  const headings = Array.from(titles).map(title => {
    const depth = parseInt($(title).prop('tagName').substring(1), 10);
    let id = getTitleId(title);
    return { url: `#${id}`, title: $(title).text(), depth };
  });

  if (headings[0] && headings[0].depth > 2) {
    headings[0].depth = 2;
  }
  return { items: groupHeadings(0, [], headings) };
};

export const groupHeadings = (index, grouping, headings) => {
  if (index < headings.length) {
    const nextHeading = headings[index];

    if (grouping.length) {
      const prevHeading = grouping.slice().pop();
      try {
        if (nextHeading.depth > prevHeading.depth) {
          prevHeading.items = prevHeading.items || [];
          return groupHeadings(index, prevHeading.items, headings);
        } else if (nextHeading.depth === prevHeading.depth) {
          grouping.push({ ...nextHeading });
          return groupHeadings(++index, grouping, headings);
        } else {
          throw { index: index, heading: nextHeading };
        }
      } catch (higherHeading) {
        if (higherHeading.heading.depth === prevHeading.depth) {
          grouping.push({ ...higherHeading.heading });
          return groupHeadings(++higherHeading.index, grouping, headings);
        } else {
          throw higherHeading;
        }
      }
    } else {
      grouping.push({ ...nextHeading });
      groupHeadings(++index, grouping, headings);
    }
  }

  return grouping;
};
